import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Sentry: nos avisa a nosotros cuando algo falla de verdad en la app, antes de que
// tengamos que enterarnos porque un cliente escribe quejándose. Configurado a propósito
// para NO enviar datos personales de nadie (userInfo: false, sin cuerpos de peticiones) —
// solo información técnica (en qué función falló, qué navegador, etc.).
Sentry.init({
  dsn: "https://577fc54dfa4bc186afb7baef4695fa5c@o4511779689201664.ingest.de.sentry.io/4511779745890384",
  dataCollection: {
    userInfo: false,
    httpBodies: [],
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Registro del Service Worker (21 sep 2026) — es el requisito que le faltaba a la app para que
// Chrome pueda ofrecer el recuadro de "Instalar Horia". El manifest.json ya estaba bien montado;
// solo faltaba esto. El propio sw.js (en /public) no cachea nada a propósito, para no repetir
// los líos de versiones viejas quedándose pegadas que ya tuvimos con la app.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.error('No se pudo registrar el Service Worker:', err);
    });
  });
}